
import pageMixin from "@/mixins/pageMixin"
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"
import HeroBannerHomepage from "@soenergy/frontend-library/src/components/HeroBannerHomepage"
import { getEnrolmentEntryUrl } from "@/helpers/enrolmentJourneyHelper"

export default {
  components: {
    HeroBannerHomepage,
    ContentBlockList
  },
  storyId: "home",
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({ id: "home" })
  },
  computed: {
    hero() {
      return this.content && this.content.hero[0]
    }
  },
  methods: {
    handleValidPostcode(validPostcode) {
      this.$store.dispatch("quote/setPostcodeAndReset", validPostcode)
      this.$router.push(getEnrolmentEntryUrl())
      this.$analytics.sendEvent(
        this.hero
          ? this.hero.postcodeSubmittedAnalyticsEvent
          : { name: "Submitted postcode" }
      )
    }
  }
}
